import { redirect } from 'react-router-dom';
import { checkUserToken } from 'utils/author';
import { getReturnUrlFromRequestLoader } from 'utils/common/route';
import { getWalmartAuthorizationParams } from 'hooks/router';
import { getPostFlowUrl } from 'utils/common/route';
import storeApp from 'store/storeApp';

export const loginOtpLoader = ({ request }) => {
  const returnUrl = getReturnUrlFromRequestLoader(request);
  const { walmartSearchQuery } = getWalmartAuthorizationParams(request);

  const state = storeApp.getState();
  const mfaLoginInfo = state?.user?.mfaLoginInfo;
  const isUserLoggedIn = checkUserToken();

  // ✅ Case 1: User is logged in and no MFA session → proceed to next step
  if (isUserLoggedIn && !mfaLoginInfo) {
    const dispatch = storeApp.dispatch;
    const nextUrl = getPostFlowUrl({
      type: 'login-otp',
      returnUrl,
      dispatch,
    });
    throw redirect(nextUrl);
  }

  // ✅ Case 2: Not logged in, no MFA session → redirect to login
  if (!isUserLoggedIn && !mfaLoginInfo) {
    if (walmartSearchQuery) {
      throw redirect(`/login${walmartSearchQuery}`);
    } else {
      throw redirect(
        `/login?returnUrl=${encodeURIComponent(returnUrl || '/')}`
      );
    }
  }

  // ✅ Case 3: Has MFA session → ONLY return data if mfaLoginInfo exists
  if (mfaLoginInfo) {
    return {
      mfaLoginInfo,
      isUserLoggedIn,
      returnUrl: returnUrl || '/',
    };
  }

  throw redirect(`/login?returnUrl=${encodeURIComponent(returnUrl || '/')}`);
};
